import md5 from 'md5';

export default (token, isLongterm) => {
  /*
    NOTE: This is being done because of a utility check in Account.js,
          in the legacy bundle.
  */

  const hashedRefreshToken = md5(token);
  const firstChunk = Math.floor(Date.now() / 1000);
  const secondChunk = hashedRefreshToken;

  if (isLongterm) {
    return encodeURIComponent(`${firstChunk}|${secondChunk}|1`);
  }

  return encodeURIComponent(`${firstChunk}|${secondChunk}|0`);
};
